import React, {PureComponent} from 'react'
import cn from 'classnames'
import {connect} from 'react-redux'
import injectSheet, {withTheme} from 'react-jss'
import {TweenLite} from 'gsap'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { getUniversalMobileMenuIsOpen, getCurrentLocation } from '../../selectors'
import NavItem from "./NavItem"
import {genderEmpty} from "../../utils/gender"
import SearchIcon from "./SearchIcon"

class EditionMobileNav extends PureComponent {
  targetElement = null;

  componentDidMount() {
    this.targetElement = document.querySelector('#mobileNavWrapper')
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks()
  }

  componentWillReceiveProps(newProps) {
    const { mobileMenuOpen } = newProps;
    if ( this._ref ) {
      if(mobileMenuOpen) {
        disableBodyScroll(this.targetElement)
        TweenLite.set(this._ref, { display: 'block' });
      } else {
        enableBodyScroll(this.targetElement)
        TweenLite.set(this._ref, { display: 'none' });
      }
    }
  }

  _isMenuSelected = (menu) => {
    const {location} = this.props;
    return location.pathname === menu.url;
  }

  _getUrlWithGender = (url, gender) => {
    if(!gender || gender === genderEmpty) return url;
    return url + "?g=" + gender;
  }

  _setRef = (ref) => this._ref = ref;

  render() {
    const { classes, className, mobileMenuOpen } = this.props;
    
    return (
      <div id="mobileNavWrapper" className={classes.wrapper}>
        <div className={cn(classes.container, className)} ref={this._setRef} style={{ display: mobileMenuOpen ? 'block' : 'none' }}>
          <div className={classes.mainNavContainer}>
            <div className={classes.actionItems}>
              <SearchIcon classNames={classes} />
            </div>
            <div className={classes.shopButtonContainer}>
              <ul>
                <NavItem
                  label='SHOP THE ICONIC'
                  url="https://www.theiconic.com.au/"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mobileMenuOpen: getUniversalMobileMenuIsOpen(state),
    location: getCurrentLocation(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)( injectSheet(theme => (
  {
    wrapper: {
      display: 'block',
      [theme.breakpoint("tablet")]: {
          display: 'none'
      }
    },
    container: {
      backgroundColor: theme.colors.white,
      position: 'fixed',
      top: 56,
      left: 0,
      right: 0,
      minHeight: '100vh',
      height: '100vh',
      paddingBottom: '100px',
      overflow: 'scroll',
      paddingTop: 4,
      '&:before': {
        content: '""',
        display: 'block',
        borderTop: `1px solid ${theme.colors.white}`,
        position: 'absolute',
        top: -1,
        left: -20,
        right: -20
      },
    },
    mainNavItem: {
      justifyContent: 'flex-start',
      borderBottom: `1px solid ${theme.colors.faintGrey}`,
      '& > a, &.selected > a': {
        width: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        opacity: 1,
        color: '#464646',
        letterSpacing: 0.9,
        lineHeight: '54px',
        fontSize: '14px !important'
      },
      "& a, & span": {
        width: '100%',
        color: theme.colors.black,
        '&:hover': {
          color: theme.colors.primary
        }
      }
    },
    shopButtonContainer: {
      '& > ul': {
        margin: 0,
        padding: 0,
        backgroundColor: '#EFEFEF',
        '& > li': {
          borderBottom: `1px solid ${theme.colors.faintGrey}`,
          '& > a, &.selected > a': {
            width: '100%',
            height: 54,
            justifyContent: 'flex-start',
            opacity: 1,
            color: '#464646',
            letterSpacing: 0.9,
            backgroundColor: '#EFEFEF',
          }
        },
      }
    },
    searchLink: {
      display: 'block',
      marginRight: 14
    },
    actionItems: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.colors.faintGrey}`,
    },
    newsletterTitle: {
      ...theme.font.familyBoldStyle,
      fontSize: 14,
      color: theme.colors.black,
      letterSpacing: 0.3,
      lineHeight: '20px',
      padding: [32, 20, 10],
      textTransform: 'none'
    },
    newsletterRoot: {
      display: 'flex',
      padding: [0, 20, 0],
      maxWidth: '100%',
      [theme.breakpoint("tablet")]: {
        maxWidth: 640
      }
    },
    newsletterActions: {
      
    },
    newsletterLink: {
      borderWidth: 1,
      borderColor: 'rgba(176, 176, 176, 0.5)',
      borderRadius: 3,
      marginLeft: 16,
      fontSize: 10,
      letterSpacing: 0.26,
      color: theme.colors.black,
      width: 100,
      padding: [0, 16],
      justifyContent: 'center',
      minHeight: 32,
      height: 32,
    },
    newsletterFields: {
      marginBottom: 0,
      minHeight: 32
    },
    newsletterGender: {
      display: 'none'
    },
    newsletterEmail: {
      width: '100%'
    },
    newsletterEmailInput: {
      marginLeft: 0,
      fontSize: 12
    },
    newsletterMessage: {
      padding: [0, 20],
      color: theme.colors.black,
    },
    fadeOut: {
      opacity: 0,
      transition: 'opacity 10s'
    },
    error: {
      margin: 0,
      top: '100%',
      bottom: 'auto'
    }
  })
)(withTheme(EditionMobileNav)) );



// WEBPACK FOOTER //
// ./src/components/UniversalNav/EditionMobileNav.js